export default __webpack_public_path__ + "static/our-mission1-ce5ef30e8462315a92ffe4c6eb1e5510.png";